/* eslint-disable react/jsx-props-no-spreading */
import { Menu } from "antd";
import { NavLink } from "react-router-dom";

const NavMenu = () => {
  return (
    <Menu
      style={{ width: "100%", minWidth: 240 }}
      defaultSelectedKeys={
        window.location.pathname === "/kd/about-us/"
          ? ["1"]
          : window.location.pathname === "/kd/about-us/members/"
          ? ["2"]
          : window.location.pathname === "/kd/about-us/partners/"
          ? ["3"]
          : [""]
      }
      mode="inline"
    >
      <Menu.Item key="1">
        <NavLink exact to="/kd/about-us/" activeStyle={{ color: "white" }}>
          Om oss
        </NavLink>
      </Menu.Item>
      <Menu.Item key="2">
        <NavLink to="/kd/about-us/members/" activeStyle={{ color: "white" }}>
          Medlemmer
        </NavLink>
      </Menu.Item>
      <Menu.Item key="3">
        <NavLink to="/kd/about-us/partners/" activeStyle={{ color: "white" }}>
          Samarbeidspartnere
        </NavLink>
      </Menu.Item>
    </Menu>
  );
};

export default NavMenu;
